import { Injectable } from '@angular/core';
import { CommonService } from '../../services/common.service';

@Injectable({
  providedIn: 'root',
})
export class datePickerService {
    constructor(private commonService: CommonService) {}
    getHolidayDates(user,id,year) {
        const urlParam = [
          'users', user, id, year
        ];
        const apiUrl = this.commonService.constructUrl(urlParam);
        return this.commonService.getData(apiUrl);
      }
}
